module.exports = __webpack_public_path__ + "img/profile_credential_015.62722ddb.png";